<footer class="footer ">
    <div class="container-fluid">
        <div class="copyright">
            &copy;
            {{copyRightDate | date: 'yyyy'}},
            <a href="https://albert-ing.com/" target="_blank">albert.ing GmbH</a>
        </div>
        <!-- <div class="oss-license-notice">
            Bootstrap &copy; 2011-2022 The Bootstrap Authors, Twitter, Inc. &mdash;
            <a href="https://github.com/twbs/bootstrap/blob/main/LICENSE" target="_blank" rel="noopener">MIT License</a>
        </div> -->
    </div>
</footer>
